import { FaSearch, FaPaperPlane } from 'react-icons/fa';
import { TiSocialLinkedin } from 'react-icons/ti';
import { Link } from 'react-router-dom';
import { useState } from 'react';
import axios from 'axios';
import Footer from '../components/Footer';
import './Questions.css';


const Questions = () => {
    const [messages, setMessages] = useState([]);
    const [inputMessage, setInputMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const sendMessage = async () => {
        if (!inputMessage.trim()) return;

        const userMessage = { role: 'user', content: inputMessage };
        setMessages(prev => [...prev, userMessage]);
        setInputMessage('');
        setIsLoading(true);

        try {
            const response = await axios.post('https://buzzinguniverse.com/backend/api/get-query-response', {
                messages: [...messages, userMessage],
            });

            if (response.data.status) {
                const aiMessage = {
                    role: 'assistant',
                    content: response.data.answer, 
                };
                setMessages(prev => [...prev, aiMessage]);
            } else {
                const errorMessage = {
                    role: 'assistant',
                    content: response.data.message || 'Something went wrong, please try again.',
                };
                setMessages(prev => [...prev, errorMessage]);
            }
        } catch (error) {
            console.error('Error:', error);
            const errorMessage = {
                role: 'assistant',
                content: 'Sorry, I encountered an error. Please try again.',
            };
            setMessages(prev => [...prev, errorMessage]);
        } finally {
            setIsLoading(false);
        }
    };


    return (
        <div>
            <div className="questions-section">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-9 col-md-9 col-12">
                            <div className={`frequently-asked-questions-box ${messages.length !== 0 && 'full'}`}>
                                <h3>Questions</h3>
                                {messages.length !== 0 && <div className="frequently-asked-questions-box">
                                    <div className="ai-chat-messages">
                                        {messages.length === 0 && (
                                            <div className="empty-chat">Ask me anything!</div>
                                        )}
                                        {messages.map((msg, index) => (
                                            <div key={index} className={`message ${msg.role} animate-in`}>
                                                <div className="message-content">
                                                    {msg.content}
                                                </div>
                                            </div>
                                        ))}
                                        {isLoading && (
                                            <div className="loading animate-pulse">
                                                <div className="typing-indicator">
                                                    <span></span>
                                                    <span></span>
                                                    <span></span>
                                                </div>
                                                Thinking...
                                            </div>
                                        )}
                                    </div>
                                </div>}
                                <div className='question-form'>
                                    <input
                                        type="text"
                                        value={inputMessage}
                                        onChange={(e) => setInputMessage(e.target.value)}
                                        onKeyPress={(e) => e.key === 'Enter' && sendMessage()}
                                        placeholder="Ask your question..."
                                        disabled={isLoading} />
                                    <button onClick={sendMessage} disabled={isLoading || !inputMessage.trim()}><FaSearch /></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />


        </div>
    )
}

export default Questions
